import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Xray",
  [
    [
      "path",
      {
        d: "M10.07,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M13.33,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M4.86,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M7.46,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M21.14,2.64H2.91C1.4,2.64.18,3.87.18,5.37v13.03c0,1.51,1.22,2.73,2.73,2.73h18.24c1.51,0,2.73-1.22,2.73-2.73V5.37c0-1.5-1.22-2.73-2.73-2.73ZM22.32,5.37v13.03c0,.65-.53,1.18-1.18,1.18H2.91c-.65,0-1.18-.53-1.18-1.18V5.37c0-.65.53-1.18,1.18-1.18h18.24c.65,0,1.18.53,1.18,1.18Z",
      },
    ],
    [
      "path",
      {
        d: "M19.19,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M16.58,6.55c-.43,0-.78.35-.78.78v9.12c0,.43.35.78.78.78s.78-.35.78-.78V7.33c0-.43-.35-.78-.78-.78Z",
      },
    ],
  ],
  "currentColor"
);
